import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';

class OfferBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uniqueId: localStorage.getItem('token'),
            username: this.props.clientName,
            value: ''
        };
         
        this.handleChange = this.handleChange.bind(this);
        this.submitMessageAccept = this.submitMessageAccept.bind(this);
        this.submitMessageRefuse = this.submitMessageRefuse.bind(this);
        this.submitMessageOffer = this.submitMessageOffer.bind(this);
    }

    componentDidMount() {
        // this.props.getCaseInfo(this.props.caseId);
        this.props.getCaseInfo(this.props.caseId, localStorage.getItem('token'));
        this.checkLanguage()
          
    }
    checkLanguage = function() {
        try{
          if (this.props.isLoading){
            setTimeout(()=>{this.checkLanguage()},100)
          }
          else{
            console.log('this caseData: '+JSON.stringify(this.props.caseData))
            var lang = localStorage.getItem('language');
            if (this.props !== undefined){
              if (this.props.caseData !== undefined){
                if (this.props.caseData.language !== undefined){
                  if (this.props.caseData.language == 'Chi'){
                    if (lang == 'en' || lang == undefined){
                      localStorage.setItem('language', 'cn');
                      setTimeout(()=>{
                          window.location.reload();
                      },100)
                    }
                  }
                  else if (this.props.caseData.language == 'Eng'){
                    if (lang == 'cn' || lang == undefined){
                      localStorage.setItem('language', 'en');
                      setTimeout(()=>{
                          window.location.reload();
                      },100)
                    }
                  }
                }
              }
            }
          }
        }catch(err){
          setTimeout(()=>{this.checkLanguage()},100)
        }
      }
    componentDidUpdate() {
        // this.scrollToBot();
    }
   
    handleChange(event) {
        this.setState({value: event.target.value});
        console.log('handleChange: '+this.state.value)
      }

      //localStorage.getItem('token')

    submitMessageAccept(e) {
        e.preventDefault();
        console.log('submitMessageAccept: '+(this.state.value));
        let userType = '';
        
        if(this.props.claimantUniqueId == this.state.uniqueId){
            userType = 'claimant';
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            userType = 'respondent';
        }

        // if(this.props.caseData.claimantUniqueId == this.state.uniqueId){
        //     userType = 'claimant';
        // }
        // else if(this.props.caseData.respondentUniqueId == this.state.uniqueId){
        //     userType = 'respondent';
        // }

        

        if (userType == 'respondent'){
            console.log('OfferBox Accept respondent: '+(this.props.claimantOffer));
            if (this.props.claimantOffer !== undefined){
                this.props.setAcceptOffer(this.props.caseId, userType, this.props.claimantOffer, localStorage.getItem('token'));
            }
            else{
                this.props.setAddOfferError();
            }
        }

        if (userType == 'claimant'){
            if (this.props.respondentOffer !== undefined){
                console.log('OfferBox Accept claimant: '+(this.props.respondentOffer));
                this.props.setAcceptOffer(this.props.caseId, userType, this.props.respondentOffer, localStorage.getItem('token'));
            }
            else{
                this.props.setAddOfferError();
            }
        }
    }

    submitMessageRefuse(e) {
        e.preventDefault();
        console.log('submitMessageRefuse: '+(this.state.value));
        let userType = '';
        if(this.props.claimantUniqueId == this.state.uniqueId){
            userType = 'claimant';
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            userType = 'respondent';
        }

        // if(this.props.caseData.claimantUniqueId == this.state.uniqueId){
        //     userType = 'claimant';
        // }
        // else if(this.props.caseData.respondentUniqueId == this.state.uniqueId){
        //     userType = 'respondent';
        // }

        

        if (userType == 'respondent'){
            console.log('OfferBox Refuse respondent: '+(this.state.claimantOffer));
            if (this.props.claimantOffer !== undefined){
                this.props.setRefuseOffer(this.props.caseId, userType, this.props.claimantOffer , localStorage.getItem('token'));
            }
            else{
                this.props.setAddOfferError();
            }
        }

        if (userType == 'claimant'){
            console.log('OfferBox Refuse claimant: '+(this.state.respondentOffer));
            if (this.props.respondentOffer !== undefined){
                this.props.setRefuseOffer(this.props.caseId, userType, this.props.respondentOffer, localStorage.getItem('token'));
            }
            else{
                this.props.setAddOfferError();
            }
        }
   
        
    }

    submitMessageOffer(e) {
        e.preventDefault();
        console.log('submitMessageOffer: '+this.state.value);
        console.log('submitMessageOffer respondentUniqueId: '+this.props.respondentUniqueId);
        console.log('submitMessageOffer claimantUniqueId: '+this.props.respondentUniqueId);
        console.log('submitMessageOffer UniqueId: '+this.state.uniqueId);
        
        let userType = '';
        if(this.props.claimantUniqueId == this.state.uniqueId){
            userType = 'claimant';
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            userType = 'respondent';
        }

        // if(this.props.caseData.claimantUniqueId == this.state.uniqueId){
        //     userType = 'claimant';
        // }
        // else if(this.props.caseData.respondentUniqueId == this.state.uniqueId){
        //     userType = 'respondent';
        // }


        if (this.state.value !== ''){
            this.props.setOffer(this.props.caseId, userType, this.state.value, localStorage.getItem('token'));
        }
        console.log('The claimantOffer is : '+this.props.claimantOffer);
    }

    render() {
        
        return ( 
            <div className="chatroom" style={{padding:'50px'}}>
                <Grid
                container
                direction="row"
                justify="center"
                alignContent="center"
                >
                    <Grid item xs={12} >
                    {(this.props.respondentOfferStatus == true &&
                    <p>{this.context.t('Respondent has accepted offer')}.</p>)}
                    {(this.props.claimantOfferStatus == true &&
                    <p>{this.context.t('Claimant has accepted offer')}.</p>)} 

                    {(this.props.respondentOfferStatus == false &&
                    <p>{this.context.t('Respondent has refused offer')}.</p>)}
                    {(this.props.claimantOfferStatus == false &&
                    <p>{this.context.t('Claimant has refused offer')}.</p>)} 

                    {(this.props.AddOfferError !== undefined && this.props.AddOfferError == true &&
                    <p>{this.context.t('An error occurred, please try again / or offer was made by the other party.')}.</p>)}
                    </Grid>
                    
                    <Grid item item xs={12}>
                        <p className="RedColor" style={{fontSize:'17px', fontFamily:'Times New Roman Georgia', fontWeight:'bold'}}>{this.context.t('Claimant Offer')}:</p>
                        {this.props.claimantOffer !== undefined && <p >HK${this.props.claimantOffer}</p>} 
                        {this.props.claimantOffer == undefined && <p >{this.context.t('No offer yet')}.</p>} 
                    </Grid>

                    <Grid item item xs={12}>
                        <p className="RedColor" style={{fontSize:'17px', fontFamily:'Times New Roman Georgia', fontWeight:'bold'}}>{this.context.t('Respondent Offer')}:</p>
                        {this.props.respondentOffer !== undefined && <p >HK${this.props.respondentOffer}</p>} 
                        {this.props.respondentOffer == undefined && <p >{this.context.t('No offer yet')}.</p>} 
                    </Grid>

                    <Grid item item xs={12}>
                    {(this.props.respondentOfferStatus == false || this.props.respondentOfferStatus == undefined) &&
                        (this.props.claimantOfferStatus == false || this.props.claimantOfferStatus == undefined) && 
                        <input type="number" value={this.state.value} onChange={this.handleChange} 
                        ref="msg" placeholder={this.context.t('Make a new offer')}/>}
                    </Grid>
                        <Grid
                            container
                            style={{marginTop:'10px'}}
                            justify="center"
                            > 
                           
                                 <Grid item xs={4} md={4} lg={2} sm={4} >
                                    {(this.props.respondentOfferStatus == false || this.props.respondentOfferStatus == undefined) &&
                                    (this.props.claimantOfferStatus == false || this.props.claimantOfferStatus == undefined) && 
                                    <input type="submit" style={{ 
                                                                    background: '#a52423',
                                                                    border: '2px solid #a52423',
                                                                    color: '#FFFFFF',
                                                                    height: '30px',
                                                                    width: '70px',
                                                                    fontSize: '14px',
                                                                    boxSizing: 'border-box',
                                                                    borderRadius: '5px',
                                                                    cursor: 'pointer',
                                                                    transition: 'all 0.3s ease'
                                                            }} 
                                                         name="button_1"
                                                         onClick={this.submitMessageAccept}
                                                         value={this.context.t('Accept')} /> }
                                 </Grid>

                                 <Grid item xs={4} md={4} lg={2} sm={4}>
                                    {(this.props.respondentOfferStatus == false || this.props.respondentOfferStatus == undefined) &&
                                    (this.props.claimantOfferStatus == false || this.props.claimantOfferStatus == undefined) && 
                                    <input type="button" style={{ 
                                                                    background: '#a52423',
                                                                    border: '2px solid #a52423',
                                                                    color: '#FFFFFF',
                                                                    height: '30px',
                                                                    width: '70px',
                                                                    fontSize: '14px',
                                                                    boxSizing: 'border-box',
                                                                    borderRadius: '5px',
                                                                    cursor: 'pointer',
                                                                    transition: 'all 0.3s ease'
                                                            }} 
                                                        name="button_2" 
                                                        onClick={this.submitMessageRefuse}
                                                        value={this.context.t('Refuse')} />} 
                                 </Grid>

                                 <Grid item xs={4} md={4} lg={2} sm={4}>
                                    {(this.props.respondentOfferStatus == false || this.props.respondentOfferStatus == undefined) &&
                                    (this.props.claimantOfferStatus == false || this.props.claimantOfferStatus == undefined) && 
                                    <input type="button" style={{ 
                                                                background: '#a52423',
                                                                border: '2px solid #a52423',
                                                                color: '#FFFFFF',
                                                                height: '30px',
                                                                width: '70px',
                                                                fontSize: '14px',
                                                                boxSizing: 'border-box',
                                                                borderRadius: '5px',
                                                                cursor: 'pointer',
                                                                transition: 'all 0.3s ease'
                                                        }}  
                                                         name="button_3" 
                                                         onClick={this.submitMessageOffer}
                                                         value={this.context.t('Offer')} />}
                                 </Grid>
                        </Grid>

                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        caseId: state.caseInfo.caseId,
        claimantUniqueId: state.caseInfo.claimantUniqueId,
        respondentUniqueId: state.caseInfo.respondentUniqueId,
        claimant_name: state.caseInfo.claimant_name,
        respondent_name: state.caseInfo.respondent_name,
        userType: state.caseInfo.userType,
        clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
        claimantOffer: state.caseInfo.claimantOffer,
        respondentOffer: state.caseInfo.respondentOffer,
        claimantOfferStatus: state.caseInfo.claimantOfferStatus,
        respondentOfferStatus: state.caseInfo.respondentOfferStatus,
        AddOfferError: state.caseInfo.AddOfferError,
        caseData: state.caseInfo.caseData,
        // getChatError: state.chatroom.getChatError,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
            getCaseInfo: (caseId) => dispatch(actions.getCaseInfo(caseId)),
            setOffer: (caseId, userType, offer, uniqueId) => dispatch(actions.setOffer(caseId, userType, offer, uniqueId)),
            setAcceptOffer: (caseId, userType, offer, uniqueId) => dispatch(actions.setAcceptOffer(caseId, userType, offer, uniqueId)),
            setRefuseOffer: (caseId, userType, offer, uniqueId) => dispatch(actions.setRefuseOffer(caseId, userType, offer, uniqueId)),
            setAddOfferError: () => dispatch(actions.setAddOfferError())
        //    saveChatMsg: (payload) => dispatch(actions.saveChatMsg(payload)),
        //    getAllChatMsg: (caseId) => dispatch(actions.getAllChatMsg(caseId)),
    }
}

OfferBox.contextTypes = {
    t: PropTypes.func
  }

export default (connect(mapStateToProps, mapDispatchToProps)(OfferBox));